import React from "react";

export default function TableBodyCol({ tableBodyLable }) {
    return (

        <td>{tableBodyLable}</td>

    )
}